import { render } from "./CommentContent.vue?vue&type=template&id=12850017&scoped=true"
import script from "./CommentContent.vue?vue&type=script&lang=js"
export * from "./CommentContent.vue?vue&type=script&lang=js"

import "./CommentContent.vue?vue&type=style&index=0&id=12850017&scoped=true&lang=css"

import exportComponent from "C:\\Apps\\AppBase\\app-base-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-12850017"]])

export default __exports__